var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item",class:{selected:_vm.isSelected()},on:{"mouseover":_vm.setMouseOver,"mouseout":_vm.unsetMouseOver}},[_c('router-link',{staticClass:"link",attrs:{"to":{name: _vm.to, query: _vm.query}}},[_vm._t("default")],2),_vm._v(" "),_c('span',{staticClass:"border"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eefffab2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/globals/NavItem.vue
// module id = null
// module chunks = 